import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
} from '@mui/material';
import {
  Shield as ShieldIcon,
  Home as HomeIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';

const colors = {
  bg: '#111827',
  primary: '#B25373',
  primaryHover: '#8E3D59',
  textWhite: '#ffffff',
  textGray400: '#9ca3af',
  textGray500: '#6b7280',
  danger: '#ef4444',
  dangerBg: 'rgba(239, 68, 68, 0.1)',
  border: '#374151',
};

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  const btnBase: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    padding: '10px 20px',
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'inherit',
    cursor: 'pointer',
    border: 'none',
  };

  return (
    <Box
      dir="rtl"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.bg,
        padding: '48px 16px',
      }}
    >
      <Box sx={{ maxWidth: 448, width: '100%', display: 'flex', flexDirection: 'column', gap: 4, textAlign: 'center' }}>
        {/* Icon */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box sx={{ width: 80, height: 80, borderRadius: '50%', backgroundColor: colors.dangerBg, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
            <ShieldIcon sx={{ fontSize: 48, color: colors.danger }} />
          </Box>
          <Typography sx={{ fontSize: 30, fontWeight: 800, color: colors.textWhite, lineHeight: 1.3 }}>
            دسترسی غیرمجاز
          </Typography>
          <Typography sx={{ mt: 1.5, fontSize: 14, color: colors.textGray400, lineHeight: 1.8 }}>
            شما مجوز لازم برای دسترسی به این صفحه را ندارید.
          </Typography>
          <Typography sx={{ mt: 1, fontSize: 14, color: colors.textGray500, lineHeight: 1.8 }}>
            لطفاً با مدیر سیستم تماس بگیرید.
          </Typography>
        </Box>

        {/* Actions */}
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
          <button
            onClick={() => navigate('/')}
            style={{
              ...btnBase,
              flex: 1,
              color: colors.textWhite,
              backgroundColor: colors.primary,
            }}
            onMouseEnter={(e) => (e.target as HTMLElement).style.backgroundColor = colors.primaryHover}
            onMouseLeave={(e) => (e.target as HTMLElement).style.backgroundColor = colors.primary}
          >
            <HomeIcon sx={{ fontSize: 18 }} />
            بازگشت به داشبورد
          </button>

          <button
            onClick={() => navigate(-1)}
            style={{
              ...btnBase,
              flex: 1,
              color: colors.textGray400,
              backgroundColor: 'transparent',
              border: `1px solid ${colors.border}`,
            }}
          >
            <ArrowBackIcon sx={{ fontSize: 18 }} />
            صفحه قبلی
          </button>
        </Box>

        {/* Notice */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontSize: 12, color: colors.textGray500, lineHeight: 1.8 }}>
            این بخش امن مدیریت است. تمام فعالیت‌ها ثبت و نظارت می‌شوند.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Unauthorized;
